import axios from "axios";

export type FindPlaceCandidate = {
  id?: string;
  formattedAddress?: string;
  addressComponents?: Array<{
    longText?: string;
    shortText?: string;
    types?: string[];
    languageCode?: string;
  }>;
  location?: {
    latitude: number;
    longitude: number;
  };
  iconMaskBaseUri?: string;
  displayName?: {
    text: string;
    languageCode?: string;
  };
};

export type FindPlaceFromTextResponse = {
  places?: FindPlaceCandidate[];
};

/** Options for `places:searchText` (merged into the JSON body after `textQuery`). */
export type SearchPlacesOptions = Partial<{
  maxResultCount: number;
  languageCode: string;
  regionCode: string;
  includedType: string;
  strictTypeFiltering: boolean;
  locationBias: unknown;
  locationRestriction: unknown;
}>;

const placesHttps = axios.create({
  baseURL: "https://places.googleapis.com/v1",
  headers: {
    "Content-Type": "application/json",
    "X-Goog-Api-Key": process.env.REACT_APP_GOOGLE_API_KEY ?? "",
    "X-Goog-FieldMask":
      "places.displayName,places.formattedAddress,places.location,places.iconMaskBaseUri,places.id,places.addressComponents",
  },
});

async function searchPlaces(textQuery: string, options?: SearchPlacesOptions) {
  const { data } = await placesHttps<FindPlaceFromTextResponse>({
    method: "post",
    url: "/places:searchText",
    data: {
      textQuery,
      ...options,
    },
  });

  return data;
}

export { searchPlaces };
